import React, { useEffect, useMemo, useState } from 'react';
import SiteNav from './components/SiteNav';
import BookCard from './components/BookCard';
import { API_URL, groupByFirstLetter } from './utils/books';
import './App.css';

function BooksIndexPage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBookId, setSelectedBookId] = useState(null);
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/books`)
      .then((response) => response.json())
      .then((data) => {
        setBooks(data.books || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const sections = useMemo(
    () => groupByFirstLetter(books, (book) => book.name || 'Untitled'),
    [books]
  );

  const selectedBook = books.find((book) => book.id === selectedBookId) || null;

  const handleSelectBook = (bookId) => {
    if (selectedBookId === bookId) {
      setSelectedBookId(null);
      setFlipped(false);
      return;
    }
    setSelectedBookId(bookId);
    setFlipped(false);
  };

  return (
    <div
      className="App index-page"
      style={{
        backgroundImage: `url('/background/background.png')`,
        backgroundColor: '#f0f0f0'
      }}
    >
      <SiteNav />
      <header className="App-header index-header">
        <div className="index-panel">
          <h2 className="index-title">All Books</h2>
          <p className="index-subtitle">Browse alphabetically. Click a title to open the book card.</p>

          {loading && <p className="index-status">Loading books...</p>}
          {error && <p className="index-status">Error: {error}</p>}

          {!loading && !error && sections.length === 0 && (
            <p className="index-status">No books found.</p>
          )}

          {sections.map(({ letter, items }) => (
            <section key={letter} className="alpha-section" id={`books-${letter}`}>
              <h3 className="alpha-heading">{letter}</h3>
              <ul className="alpha-list">
                {items.map((book) => (
                  <li key={book.id}>
                    <button
                      type="button"
                      className={`alpha-list-button ${selectedBookId === book.id ? 'active' : ''}`}
                      onClick={() => handleSelectBook(book.id)}
                    >
                      <span className="alpha-list-title">{book.name || 'Untitled Book'}</span>
                      <span className="alpha-list-meta">{book.author || 'Unknown author'}</span>
                    </button>
                    {selectedBookId === book.id && selectedBook && (
                      <div className="alpha-book-card-wrap">
                        <BookCard
                          book={selectedBook}
                          isFlipped={flipped}
                          onToggle={() => setFlipped((prev) => !prev)}
                        />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </header>
    </div>
  );
}

export default BooksIndexPage;
